import { makeStyles } from '@material-ui/core';

const useStatsCardsStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    padding: '0 25px 45px 34px',
  },
  icon: {
    color: '#4b8c6f',
    width: 24,
    height: 24,
    marginRight: 12.5,
    marginTop: 6.25,
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: 22,
    fontWeight: 'bold',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: '#000000',
  },
  subtitle: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: '#7c828a',
  },
  contentContainer: {
    width: '100%',
  },
  sliderContainer: {
    display: 'flex',
    alignItems: 'end',
  },
  sliderRail: {
    height: 8,
    borderRadius: 4,
  },
  sliderThumb: {
    height: 18,
    width: 18,
    border: '1px solid #fff',
  },
  sliderValue: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: '#000000',
    marginLeft: 10,
  },
}));

export { useStatsCardsStyles };
